import { CONSULTANT_ERROR, CONSULTANT_RECEIVE, CONSULTANT_REQUEST, EMPTY_CONSULTANT_NAME } from './ConsultantAction'

const initialState = {
	id:null,
	username:'',
	first_name:'',
	last_name:'',
	description:'',
	profile_url: '',
	services:[],
	social_networks:[],
}

const ConsultantReducer = (state = initialState, action = {}) => {
	const { type, error, consultant } = action

	switch (type) {
		case EMPTY_CONSULTANT_NAME:
		  return {
		    ...state,
		    first_name: ''
		  };

		// ------------------------------------ consultant fetch ------------------------------------
		case CONSULTANT_REQUEST:
			return {
				...state,
				isConsultantFetching: true
			}
		case CONSULTANT_RECEIVE:
			return {
				...state,
				isConsultantFetching: false,
				...consultant
			}
		case CONSULTANT_ERROR:
			return {
				...state,
				isConsultantFetching: false,
				error
			}

		default:
			return state
	}
}

export default ConsultantReducer
